import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DocumenttypeForms from "../../../components/Forms/DocumenttypeForms";
import { getTokenInfo } from "../../../utils/Guard";
import { Getdocumenttype, Updatedocumenttype } from "../../../store/documenttype-store/documenttype-actions";


let runOnce = true;

const DocumenttypeEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const documenttype = useSelector((state) => state.documenttype.documenttype);
  const userInfo = getTokenInfo();
  

  

  // useEffect(() => {
  //   if ((documenttype.id===undefined || documenttype.id === 0) && runOnce) {
  //     dispatch(Getdocumenttype(param.documenttypeId, userInfo.Email));
  //     runOnce = false;
  //   }
  // }, [param.documenttypeId, userInfo.Email, dispatch, documenttype]);

    useEffect(() => {
    if (documenttype.id===undefined || documenttype.id === 0) {
      dispatch(Getdocumenttype(param.documenttypeId, userInfo.Email));
    }
  }, [param.documenttypeId, userInfo.Email, dispatch, documenttype]);


  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "62.5rem" }}>
      <DocumenttypeForms actionDocumenttype={Updatedocumenttype} documenttype={documenttype} />
    </div>
    </>
  );
};
export default DocumenttypeEdit;
